import styled from '@emotion/styled'
import { breakpoints, colors, fonts, fontSizes } from 'src/utils/styles'
import { css } from '@emotion/react'
import { IS_BLACK_FRIDAY } from 'src/utils/globals'

const OptionStyles = css`
  list-style-type: none;
  padding: 0.25em 0;
  background-color: ${IS_BLACK_FRIDAY ? 'black' : 'white'};
  cursor: pointer;
  font-size: ${fontSizes.sortingContainerDesktop};

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.sortingContainerMobile};
  }
`

export const SelectContainer = styled.div`
  cursor: pointer;
  outline: none;
  font-family: ${fonts.regular};
  font-size: ${fontSizes.filterContainer};

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.filterContainerMobile};
  }
`
export const SelectContainerSort = styled(SelectContainer)`
  margin-left: 0;

  @media (max-width: ${breakpoints.s}px) {
    margin-left: auto;
  }
`

export const FilterText = styled.p`
  font-size: ${fontSizes.filterTextDesktop};

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.filterTextMobile};
  }
`

export const SelectValueContainerSorting = styled.div`
  outline: none;
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 0 0 0.25rem 0;
  margin-bottom: 0.5rem;
  min-width: 130px;
  visibility: ${props => (!props.showOptionList ? 'visible' : 'hidden')};

  @media (max-width: ${breakpoints.s}px) {
    min-width: 100px;
  }
`

export const OptionContainer = styled.div`
  outline: none;
  visibility: ${props => (!props.showOptionList ? 'hidden' : 'visible')};
  margin-left: 0.5rem;
  position: absolute;
  width: 100%;
  z-index: 3;
  max-width: fit-content;
  margin-top: 0 !important;
  top: 22px;
  border: 1px solid ${colors.gray};
  background-color: ${IS_BLACK_FRIDAY ? 'black' : 'white'};
  padding: 0.5em 1.25em;

  @media (max-width: ${breakpoints.s}px) {
    top: 0.5%;
  }
`

export const OptionList = styled.ul`
  padding: 0;
  margin: 0;

  li:first-of-type {
    margin-top: -0.25em;
  }
`

export const OptionContainerSort = styled(OptionContainer)`
  margin-left: -23px;

  @media (max-width: ${breakpoints.s}px) {
    margin-left: -23px;
  }

  @media (min-width: 414px) {
    margin-left: -31px;
  }

  @media (min-width: ${breakpoints.m}px) {
    margin-left: -23px;
  }
`
export const Option = styled.li`
  ${OptionStyles};
`

export const OptionBold = styled.li`
  ${OptionStyles};
  font-family: ${fonts.bold};
`

export const PlaceholderSpan = styled.span`
  color: ${colors.darkGray};
  font-size: ${fontSizes.filterTextDesktop};

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.filterTextMobile};
  }
`

export const DropdownIndicatorSort = styled.img`
  margin-top: 0.4em;
  margin-left: 0.7em;
  max-width: 1rem;

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.filterTextMobile};
    margin-left: 0.25em;
  }
`

export const Line = styled.hr`
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid ${colors.gray};
  margin-bottom: 4px;
`
